import { apiRequestWithChecks } from "./api";

export const manageMessagePlan = {
  getPage(token) {
    return apiRequestWithChecks("GET", "/api/billing/manage-message-plan/page", {
      Authorization: "Bearer " + token,
    });
  },
  getPlans(token, billingCycle) {
    const query = billingCycle ? `?billingCycle=${encodeURIComponent(billingCycle)}` : "";
    return apiRequestWithChecks("GET", `/api/billing/manage-message-plan/plans${query}`, {
      Authorization: "Bearer " + token,
    });
  },
  preview(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/billing/manage-message-plan/preview",
      { Authorization: "Bearer " + token },
      data
    );
  },
  change(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/billing/manage-message-plan/change",
      { Authorization: "Bearer " + token },
      data
    );
  },
};
